import type { FaireProductEntity } from "../../entity_types/product";

export const p_3auuoqfajy: FaireProductEntity = {
  token: "p_3auuoqfajy",
  type: "product",
  name: "IMMUNE SUPPORT | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/639445c7e2b2e8dc117f21d68dc614337e22eb9d1c4474245bd62179cb6fd545.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcf2423d3dafc58c4435b464c98f6c130f78b2a830c329a7296fc7c5f7526ad1.png",
  ],
  priceDollars: 17,
  description:
    'This 100% pure, therapeutic grade essential oil wellness blend is packed with antiviral, antibacterial, antiseptic, and antifungal properties that can help effectively fight against outside invaders that try to attack the body. It can be used reactively or proactively to help support a healthy immune system.\n\nTO USE: Apply desired amount onto bottoms of feet and spine morning and night. When sick, apply every 2 hours.\n\nINGREDIENTS: ORGANIC UNREFINED COLD PRESSED AVOCADO OIL, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: CLOVE, LEMON, CINNAMON, EUCALYPTUS, ROSEMARY, TEA TREE, FRANKINCENSE, THYME, OREGANO, GERANIUM, LEMONGRASS.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\nDimension: 10 ml, 0.75" x 3.25" x 0.75".',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:18.806Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
